module.exports = __webpack_public_path__ + "static/img/logo.6e2488f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.png
// module id = 638
// module chunks = 1